<mat-form-field appearance="outline">
  <input matInput placeholder="Select a user" (keyup)="keyUp.next($event)" aria-label="User" [matAutocomplete]="auto" i18n-placeholder i18n-aria-label
    [formControl]="selectedUser">

  <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayFn()"
    (optionSelected)="onOptionSelect()">
    <mat-option *ngIf="isLoading" class="is-loading" i18n>Loading...</mat-option>
    <ng-container *ngIf="!isLoading">
      <mat-option *ngFor="let user of users" [value]="user.doc.user">
        {{ user.fullname }} ({{ user.email}})
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
